/* import __COLOCATED_TEMPLATE__ from './interblocks-styles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();